// extracted by mini-css-extract-plugin
module.exports =  {"root":"bnHEFUfodK8livGeJk0t"};